<h2
  [class.bold]="bold"
  [innerHtml]="text"></h2>
